import React from 'react';

import { Button, ButtonProps, Link } from '@neptune/shared/venus-ui';

type SalesLink = {
  asButton?: boolean;
} & Pick<ButtonProps<{}>, 'size' | 'variant'>;

export const SalesLink: React.FC<SalesLink> = ({
  asButton,
  children,
  size = 'lg',
  variant = 'primary',
}) => {
  const href = 'mailto:sales@neptune.ai';

  if (asButton) {
    return (
      <Button
        data-role="sales-link"
        size={size}
        variant={variant}
        onClick={() => window.open(href)}
      >
        {children}
      </Button>
    );
  }

  return (
    <Link data-role="sales-link" href={href} external>
      {children}
    </Link>
  );
};
